import { apiClient } from '@/core/api';
import type { OrganizationDto } from '@/features/auth/types';

export interface OnboardOrgInput {
  name: string;
  base_currency: string;
}

/**
 * Self-serve organization creation (BE: `POST /api/organizations/onboard/`).
 * The authenticated user becomes the founding member (Super Admin + Founder).
 */
export async function onboardOrganization(input: OnboardOrgInput): Promise<OrganizationDto> {
  const { data } = await apiClient.post<OrganizationDto>('/organizations/onboard/', input);
  return data;
}
